import Vue from 'vue'
import Router from 'vue-router'

import Index from './components/store.vue'

import store from './components/store.vue'
import region from './components/region.vue'
import project from './components/project.vue'
Vue.use(Router)
const routes = [
  {
    name: 'index',
    path: '/',
    component: Index
  },
  
  {
    name: 'store',
    path: '/store',
    component: store
  },
  {
    name: 'region',
    path: '/region',
    component: region
  },
  {
    name: 'project',
    path: '/project',
    component: project
  }
]
const router = new Router({
  routes
})
export default router
